import { titleCase } from "title-case";
// Not enums/StatusType: both default-export an enum named StatusType and they differ.
import StatusType from "enums/CardStatusType";
import CardType from "enums/CardType";

// The server's CardStatus enum. It has no CLOSED; sending one fails validation.
const FILTERABLE_STATUSES: StatusType[] = [
  StatusType.ACTIVE,
  StatusType.PENDING,
  StatusType.CANCELED,
  StatusType.INACTIVE,
  StatusType.FROZEN,
  StatusType.ISSUED,
];

export const offeredStatuses = (tabStatuses: StatusType[]): StatusType[] =>
  tabStatuses.length ? tabStatuses : FILTERABLE_STATUSES;

export const narrowToTab = (
  picked: string[],
  tabStatuses: StatusType[],
): string[] => {
  const offered = offeredStatuses(tabStatuses) as string[];
  return picked.filter((status) => offered.includes(status));
};

export const composeCardStatus = (
  tabStatuses: StatusType[],
  picked: StatusType[],
): StatusType[] =>
  tabStatuses.length
    ? picked.length
      ? tabStatuses.filter((status) => picked.includes(status))
      : tabStatuses
    : picked;

export interface CardFilterCriteria {
  cardStatus: StatusType[];
  cardType: CardType[];
  userId: string | null;
  searchTerm: string;
}

// An empty list means "no status constraint", not "nothing matches".
export const CARD_TAB_STATUSES = {
  activePending: [
    StatusType.ACTIVE,
    StatusType.PENDING,
    StatusType.FROZEN,
    StatusType.ISSUED,
  ] as StatusType[],
  all: [] as StatusType[],
};

export interface CardFilterOption {
  value: string;
  label: string;
}

export const cardStatusOptions = (
  tabStatuses: StatusType[],
  t: (key: string) => string,
): CardFilterOption[] =>
  offeredStatuses(tabStatuses).map((status) => ({
    value: status,
    label: t(titleCase(status.toLowerCase())),
  }));

export const cardTypeOptions = (
  t: (key: string) => string,
): CardFilterOption[] =>
  Object.values(CardType).map((type) => ({
    value: type,
    label: t(titleCase(type.toLowerCase())),
  }));
